import {AccountEntryView} from './account_entry_view';

export class AccountHorseShowEntriesView {

  horseShowId: string = '';
  horseShowName: string = '';
  horseShowStartDate: Date = null;
  horseShowEndDate: Date = null;
  circuitId: string = '';
  circuitName: string = '';
  closed: boolean = false;
  copyAllowed: boolean = false;
  competitionOrganizerId: string = '';
  venueId: string = '';
  venueName: string = '';
  entries: AccountEntryView[] = [];

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

}
